
import axios from "axios";
import { Component } from 'react';
import { Alert, Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { hasPermission } from "../../utils/usePermission";
import CommonDetailsForm from '../CommonAddressPage/CommonDetailsForm';
import CommonTableModule from '../CommonTable/CommonTableModule';
import CommonLoader from '../loaderComponent/CommonLoader';
export default class CustomerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      loading: false,
      hasError: false,
      errMsg: "",
      showForm: false,
      selectedCustomer: null,
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/customer', { headers });
      this.setState({ customers: response.data, loading: false });
    } catch (error) {
      console.error("Error fetching customers:", error);
      let errorMessage = "Failed to load customers.";
      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }

  handleClick = (id) => {
    this.setState({ loading: true });
    let type = 'c'
    setTimeout(() => {
      const selectedCustomer = this.state.customers.find((customer) => customer.id === id);
      this.setState({ selectedCustomer, showForm: true, loading: false });
      this.props.history.push(`/customer-address/${type}/${id}`);
    }, 200);
  }
  handleUpdateCustomer = (customerData) => {
    console.log("customerData ", customerData);
    this.props.history.push({
      pathname: `/customer-edit/${customerData?.id}`,
      state: { customerData }
    });
  }

  handleAddCustomer = () => {
    this.props.history.push('/customer-add')
  }

  render() {
    const { showForm, selectedCustomer } = this.state;
    const columns = [
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
      { key: "gst", label: "GST Number" },
      { key: "pan_no", label: "Pan Number" },
      { key: "phone", label: "Phone" },
      { key: "email", label: "Email" },
      { key: "address", label: "Address" },

      // {
      //   key: "createdAt",
      //   label: "Created Date",
      //   render: (value) => DateTimeFormat(value),
      // },
      // {
      //   key: "updatedAt",
      //   label: "Updated Date",
      //   render: (value) => DateTimeFormat(value),
      // },
      {
        key: "status",
        label: "Status",
        render: (value) => {
          const status = value?.toLowerCase();
          const isActive = status === "active";

          const styles = {
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "0.75rem",
            fontWeight: 600,
            textTransform: "uppercase",
            backgroundColor: isActive ? "#E6F4EA" : "#FBEAEA",
            color: isActive ? "#216e39" : "#A94442",
            border: `1px solid ${isActive ? "#B6E2C5" : "#F1B5B5"}`,
            minWidth: "80px",
            textAlign: "center",
          };

          return (
            <span style={styles}>
              {isActive ? <FaCheckCircle /> : <FaTimesCircle />} {value}
            </span>
          );
        },
      },
      // render: (value, record) => (
      //   <div className='address-div'>
      //     <Badge variant={value === "active" ? "success" : "danger"}>{value.toUpperCase()}</Badge>
      //   </div>
      // ),
      // },
      {
        key: "action",
        label: "Action",
        render: (value, record) => (
          <div className='address-div'>
            {hasPermission("M4S2B1") && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-edit-${record.id}`}>Add Address</Tooltip>}
              >
                <Button size="sm" variant='outline-info'
                  className='info'
                  onClick={() => this.handleClick(record.id)}>
                  <i className="fa fa-plus-circle"></i>
                </Button>
              </OverlayTrigger>
            )}
            {
              hasPermission('M4S2B2') && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-edit-${record.id}`}>Update Customer </Tooltip>}
                >
                  <Button size="sm" className='info' variant='outline-info' onClick={() => this.handleUpdateCustomer(record)}>
                    <i className="fa fa-edit"></i>
                  </Button>
                </OverlayTrigger>
              )
            }

          </div>
        ),
      },
    ];


    if (showForm && selectedCustomer) {
      return (
        <CommonDetailsForm
          useType="c"
          data={selectedCustomer}
          onClose={() => this.setState({ showForm: false })}
        />
      );
    }
    return (
      <CommonLoader isLoading={this.state.loading}>
        <div className="container-fluid pt-4">
          {hasPermission('M4S1') && (
            <div className='add-role'>
              <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleAddCustomer}> <i className="fa fa-plus-circle"></i> Add Customer</Button>
            </div>
          )}
          <Card className="mb-3">
            <Card.Header>
              <b>Customer List</b>
            </Card.Header>
            <Card.Body>
              {this.state.hasError ? (
                <Alert variant="outline-danger" className="m-3">
                  {this.state.errMsg}
                </Alert>
              ) : (
                <CommonTableModule columns={columns} data={this.state.customers} />
              )}
            </Card.Body>
          </Card>
        </div>
      </CommonLoader>
    );
  }
}
